import React, { Component } from 'react';
import classnames from 'classnames/bind';
import { string, array, node } from 'prop-types';

import CopyToClipboard from '@components/CopyToClipboard/CopyToClipboard';
import Icon from 'foundations/Icons/Icon';
import InputGroup from './InputGroup/InputGroup';
import Tooltip from 'elements/Tooltip/Tooltip';
import { ListElement } from 'elements/Tooltip/Layout';
import { ShowCaseConsumer } from '../ShowCase';

const cx = classnames.bind(styles);

import styles from './Controls.css';

class Controls extends Component {
  static propTypes = {
    optionsGroup: array,
    backgrounds: array,
    className: string,
    children: node,
    codeSample: string,
  }

  renderOptions = handleOptionSelect => {
    const { optionsGroup } = this.props;
    let options = null;

    if (optionsGroup.length) {
      options = optionsGroup.map((group, i) => (
        <div className="flex flex-column flex-justify-end" key={`group-${i}`}>
          <InputGroup
            groupName={`group-${i}`}
            group={group}
            onOptionPick={handleOptionSelect}
            isFirst={i === 0}
          />
        </div>
      ));
    }

    return options;
  }

  render() {
    const { children, className } = this.props;

    return (
      <ShowCaseConsumer>
        {({ handleOptionSelect, codeSample }) => (
          <div className={cx('flex flex-justify-between', 'controls', className)}>
            <div className="flex flex-wrap">
              { this.renderOptions(handleOptionSelect) }
            </div>

            <div>
              { children }
            </div>

            <div className={styles.copyClipboard}>
              <CopyToClipboard
                dataText={codeSample}
                render={ copied =>
                  <Tooltip
                    target={
                      <Icon
                        icon={copied ? 'confirmation' : 'duplicate'}
                        type={'20'}
                        customClasses={cx('copyIcon', { 'active': copied })} />
                    }
                    open={copied}
                    placement={'top'}
                  >
                    <ListElement>Code Sample Copied!</ListElement>
                  </Tooltip>
                }
              />
            </div>
          </div>
        )}
      </ShowCaseConsumer>
    );
  }
}

export default Controls;



// WEBPACK FOOTER //
// ./src/components/ShowCase/Controls/Controls.js